<div class="card-novo-lg">
  <div class="flex flex-col md:flex-row gap-4 items-start p-4">
    <div class="w-full md:w-1/4 space-y-2">
      <div class="text-2xl font-bold text-rougeNovo mb-2">{{formation.titre}}</div>
      <div class="mt-2">
        <div class="flex items-center justify-between mb-2">
          {{ 'SCORMS_LIST.DATE' | translate }} : {{ formation.dateHeurePrevue | date: 'yyyy-MM-dd'}}
          <span class="text-sm font-medium "> {{ formation.dateHeurePrevue | date: 'HH:mm'}}</span>
        </div>
      </div>
      <div class="mt-2">
        <div class="flex items-center justify-between mb-2">
          <span class="text-sm font-medium ">{{ 'SCORMS_LIST.PLACE' | translate }} :</span> <span
        class="text-sm font-medium ">{{ formation.emplacement | tiret }}</span>
      </div>
    </div>
    <div class="mt-2">
      <div><span class="text-sm font-medium ">{{ 'SCORMS_LIST.COMMENTAIRE' | translate }} : </span></div>
      <div class="flex items-center justify-between mb-2">
        <span class="text-sm font-medium p-2">{{ formation.commentaire}}</span>
      </div>
    </div>
  </div>
  <div class="w-full md:w-1/4 flex-shrink-0">
    <div class="text-lg font-semibold mb-3">{{ 'SCORMS_LIST.GROUP_TRAINING' | translate }}</div>
    <ng-container>
      <div class="justify-center rounded-3xl shadow-md cursor-pointer hover:shadow-lg hover:scale-105 transition-transform duration-300 ease-in-out"
        [class.opacity-50]="donneeNonEnregistre()"
        [class.cursor-not-allowed]="donneeNonEnregistre()">
        <a (click)="!donneeNonEnregistre() && isValid()"
          [class.pointer-events-none]="donneeNonEnregistre()"
          class="block no-underline m-0 p-0">
          <div class="flex-col p-0 bg-black rounded-3xl h-[220px] overflow-hidden">
            <div class="flex-grow flex h-8/10">
              <img alt="img" class="w-full h-full object-cover rounded-t-3xl rounded-b-none"
                [src]="getLocalizedContent(formation.package!.locales).thumbnail"
                [alt]="getLocalizedContent(formation.package!.locales).titre + ' thumbnail'">
              </div>
              <div
                class="w-full h-2/10 pt-2 text-center object-cover footer-card transition-all duration-300 bg-black ease-in-out items-center justify-center">
                <span style="font-weight: 700;" class="p-2 text-center text-white">{{getLocalizedContent(formation.package!.locales).titre}}</span>
              </div>
            </div>
          </a>
        </div>
        @if (nombreDePresences() < 2) {
          <p class="text-center mt-2 text-red-600" >{{ 'SCORMS_LIST.WARNING_MESSAGE' | translate }}</p>
        }
        @if (isNumberAssistValid()  && !isDateStartedValid()) {
          <p class="text-center mt-2 text-red-600">{{ 'SCORMS_LIST.DATE_START_MESSAGE' | translate }}</p>
        }
      </ng-container>
    </div>

    <div class="w-full md:w-1/2">
      <div class="flex mr-9">
        <div class="text-lg font-semibold mb-3 flex-grow">{{ 'SCORMS_LIST.ALL_PARTICIPANTS' | translate }}</div>
        <div class="flex-shrink-0"><span class="mr-2">{{ 'SCORMS_LIST.SELECT_ALL' | translate }}</span>
        <input title="checkbox" (ngModelChange)="selectedAllParticipantsFn()" type="checkbox"
          [(ngModel)]="selectedAllParticipants" class="form-checkbox  h-4 w-4 transition duration-150 ease-in-out" />
        </div>
      </div>
      @if (isLoading) {
        <div class="flex justify-center items-center h-64">
          <mat-spinner color="accent"></mat-spinner>
        </div>
      }
      @if (isLoading === false) {
        <div class="space-y-4 max-h-56 overflow-y-auto pr-3 custom-scrollbar">
          @for (participant of getParticipants(); track participant) {
            <div class="w-full">
              <a class="block card-hover">
                <div class="rounded-xl overflow-hidden shadow-sm border border-gray-100 p-2 flex items-center gap-4">
                  <div class="flex-grow">
                    <div class="text-base font-medium">
                    {{ participant.prenom }} {{ participant.nom }}</div>
                  </div>
                  <div class="flex-shrink-0">
                    <input title="checkbox" type="checkbox" (ngModelChange)="selectedOne($event, participant.utilisateurId)"
                      [(ngModel)]="participant.estPresent"
                      class="form-checkbox h-4 w-4 transition duration-150 ease-in-out" />
                    </div>
                  </div>
                </a>
              </div>
            }
          </div>
        }
        <div class="flex justify-end"><button [disabled]="disabledButton()" (click)="save()"
          class="btn-primary-novo disabled:text-gray-200 disabled:border-gray-300 disabled:cursor-not-allowed disabled:bg-red-200">{{
        'SCORMS_LIST.SAVE' | translate }}</button></div>
      </div>
    </div>
  </div>
